import { WIDGET_ORIGIN } from "@/embed/widgetOrigin";

/** Absolute (cross-origin-safe) URL for a same-origin AURAL asset under /aural/.
 * Uses the captured widget origin so a card embedded on another domain still
 * loads images from the widget host, not the embedding page. Empty origin
 * (hosted page / tests) -> root-relative. */
export function assetUrl(file: string): string {
  const base = WIDGET_ORIGIN.replace(/\/+$/, "");
  return `${base}/aural/${file}`;
}
